<template>
    <div id="user-info-password">
        <a-form class="form" :form="form" @submit="handleSubmit">
            <a-form-item label="旧密码" :label-col="{ span: 4}" :wrapper-col="{ span: 12 }">
                <a-input
                    type="password"
                    placeholder="请输入旧密码"
                    v-decorator="['password',{ rules: [{ required: true, message: '请输入你的账号密码!' }] }]"
                />
            </a-form-item>
            <a-form-item label="新密码" :label-col="{ span: 4}" :wrapper-col="{ span: 12 }">
                <a-input
                    type="password"
                    placeholder="6~18位数字或字母"
                    v-decorator="['newPassword',{ rules: [
                        { required: true, message: '请输入你的新密码！' },
                        { pattern: new RegExp('^[0-9a-zA-Z]{6,18}$','g'),message:'必须是6~18位数字或字母'},
                        ]}]"
                    help="必须是6~18位数字或字母"
                />
            </a-form-item>
            <a-form-item label="确认密码" :label-col="{ span: 4}" :wrapper-col="{ span: 12 }">
                <a-input
                    type="password"
                    placeholder="请在此输入新密码"
                    v-decorator="['reNewPassword',{ rules: [
                        { required: true, message: '请再次输入你的新密码！' }
                    ]}]"
                />
            </a-form-item>
            <a-form-item
                :wrapper-col="{ span: 12, offset: 5 }"
            >
                <a-button
                    type="primary"
                    html-type="submit"
                >
                    保存
                </a-button>
            </a-form-item>
        </a-form>
    </div>
</template>

<script>
import UrlApi from "@/utils/UrlApi.js";
import Cookies from 'js-cookie';
import Mixins from "@/utils/Mixins.js";
export default {
    name:"UserInfoPassword",
    mixins:[Mixins],
    data () {
        return {
            newPassword:"",
            reNewPassword:"",
            form: this.$form.createForm(this),
        };
    },
    created(){

    },
    methods: {
       handleSubmit(e){
           e.preventDefault();
            this.form.validateFields((err, values) => {
                if (!err) {
                    if(values.newPassword !== values.reNewPassword){
                        this.$message.error("确认密码与新密码不一致，请重新输入！");
                        return;
                    }
                    let _this = this;
                    // this.$confirm({
                    //         title: '重要操作，请谨慎选择！',
                    //         content: '确定要修改密码吗？',
                    //         onOk() {
                    //             _this.updatePassword(values)
                    //         },
                    //         onCancel() {
                    //
                    //         },
                    //     });

                    this.$confirm('确定要修改密码吗?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        _this.updatePassword(values)
                    }).catch(() => {

                    });
                }
            });
            return
       },
       updatePassword(values){
           let url = UrlApi.updatePassword;
           let userId = this.$store.getters.getUserId;
           let token = this.$store.getters.getToken;
           let params = `userId=${userId}&password=${values.password}&newPassword=${values.newPassword}`
           this.$http.post(url,params,{
                headers:{
                   "Authorization":token
               }
           }).then((res)=>{
               let {message,success} = res.data;
               if(success){
                   this.reLogin();
                   return;
               }
               this.$message.error(message);
           })
       },
       // 修改密码成功 重新登录
       reLogin(){
            this.$message.success("密码修改成功,请重新登录！");
            setTimeout(()=>{
                Cookies.remove("BSG-savePassword");
                Cookies.remove("BSG-userInfo");
                let userInfo = {
                    userId: null,
                    token: null,
                    userName: null
                }
                this.upDateUserInfo(userInfo);

                this.$router.push({name:'login'})
                // let url = window.location.href.slice(0,window.location.href.indexOf("personal?edit=password"));
                // window.open(url,"_self");
            },2000)
       }
    }
}

</script>
<style lang="less" scoped>
    #user-info-password {

    }
</style>